import { centerViewport } from 'components/Parallax';

export default (el, direction, cb) => {
  let diff;
  if (el.scrollWidth > window.innerWidth) {
    diff = Math.round((el.scrollWidth - window.innerWidth) * 100) / 100;
  }

  if (direction === 'vertical') {
    if (diff) {
      document.body.style.height = `${window.innerHeight + diff}px`;
    } else if (document.body.clientHeight !== window.innerHeight) {
      document.body.style.height = '100%';
    }
  } else {
    if (diff) {
      document.body.style.width = `${window.innerWidth + diff}px`;
    } else if (document.body.clientWidth !== window.innerWidth) {
      document.body.style.width = '100%';
    }
    // const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    // if (iOS) {
    document.body.style.height = '5000%';
    // }
  }

  centerViewport();

  if (cb) cb();
};



// WEBPACK FOOTER //
// ./src/components/Parallax/utils/setBodyDimension.js